import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { StickyCallButton } from "@/components/StickyCallButton";
import React from "react";

export function SiteLayout({ children }: SiteLayoutProps) {
    return (
        <div className="min-h-screen">
            <Header />
            <main>
                {children}
            </main>
            <Footer />
            <StickyCallButton />
        </div>
    );
}

interface SiteLayoutProps {
    children: React.ReactNode;
}


